import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

/**
 * @hidden
 */
let nextPanelbarId: number = 0;

/**
 * @hidden
 */
@Injectable()
export class PanelBarService<T> {
  public children$: Observable<T>;
  public keepContent$: Observable<boolean>;
  public parent$: Observable<boolean>;
  public pbId: number;

  public onKeepContent(keepContent: boolean): void {
    this.keepContentSource.next(keepContent);
  }

  public onSelect(event: T): void {
    this.childSource.next(event);
  }

  public onFocus(): void {
    this.parentSource.next(true);
  }

  public onBlur(): void {
    this.parentSource.next(false);
  }

  constructor() {
    this.parentSource = new Subject<boolean>();
    this.keepContentSource = new BehaviorSubject<boolean>(false);
    this.childSource = new Subject<T>();

    this.parent$ = this.parentSource.asObservable();
    this.children$ = this.childSource.asObservable();
    this.keepContent$ = this.keepContentSource.asObservable();

    this.pbId = nextPanelbarId++;
  }

  private childSource: Subject<T>;
  private keepContentSource: Subject<boolean>;
  private parentSource: Subject<boolean>;
}
